import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: "https://keycloak.augment8.dev",
  realm: "Augment8_UAT",
  clientId: "frontend_client",
});

export default keycloak;
